import { render } from "./category-wizard-mobile.vue?vue&type=template&id=1789544c&scoped=true&ts=true"
import script from "./category-wizard-mobile.vue?vue&type=script&lang=ts"
export * from "./category-wizard-mobile.vue?vue&type=script&lang=ts"

import "./category-wizard-mobile.vue?vue&type=style&index=0&id=1789544c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1789544c"]])

export default __exports__